import { space8 } from 'glints-aries/es/@next/utilities/spacing';
import styled from 'styled-components';

export const StyledModalFooter = styled.div`
  display: flex;
  gap: ${space8};
  width: 100%;
  justify-content: flex-end;
`;

export const StyledInputOTPFooter = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  & > div {
    display: flex;
    gap: ${space8};
  }
`;
